/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_CreateInputs */

const cs_pipelines_create = /** @type {(inputs: Pipelines_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit pipeline`)
};

const en_pipelines_create = /** @type {(inputs: Pipelines_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create pipeline`)
};

/**
* | output |
* | --- |
* | "Create pipeline" |
*
* @param {Pipelines_CreateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_create = /** @type {((inputs?: Pipelines_CreateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_CreateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_create(inputs)
	return cs_pipelines_create(inputs)
});